module.exports = __webpack_public_path__ + "media/images/pages/home_featured/home-purchase-icon-5552fd992072f4c7d5e16a461aa2ebc6.png";